import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar.jsx';
import Footer from './components/layout/Footer.jsx';
import ScrollToTop from './components/layout/ScrollToTop.jsx';
import Home from './pages/Home.jsx';
import AimsAndScope from './pages/AimsAndScope.jsx';
import EditorialBoard from './pages/EditorialBoard.jsx';
import AuthorGuidelines from './pages/AuthorGuidelines.jsx';
import PeerReviewPolicy from './pages/PeerReviewPolicy.jsx';
import Contact from './pages/Contact.jsx';
import About from './pages/About.jsx';
import Articles from './pages/Articles.jsx';
import ArticleDetail from './pages/ArticleDetail.jsx';
import IssueDetail from './pages/IssueDetail.jsx';
import Submit from './pages/Submit.jsx';
import Login from './pages/auth/Login.jsx';
import Register from './pages/auth/Register.jsx';
import Dashboard from './pages/Dashboard.jsx';
import AdminDashboard from './pages/AdminDashboard.jsx';

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aims-and-scope" element={<AimsAndScope />} />
        <Route path="/editorial-board" element={<EditorialBoard />} />
        <Route path="/author-guidelines" element={<AuthorGuidelines />} />
        <Route path="/peer-review-policy" element={<PeerReviewPolicy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/articles" element={<Articles initialTab="articles" />} />
        <Route path="/articles/:id" element={<ArticleDetail />} />
        <Route path="/issues" element={<Articles initialTab="issues" />} />
        <Route path="/issues/:id" element={<IssueDetail />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/register" element={<Register />} />
      </Routes>
    </Layout>
  );
}

export default App;
